export default __webpack_public_path__ + "static/media/116-M6040.409da19c.png";